import * as React from 'react';
import { GridCustomCellProps } from "@progress/kendo-react-grid";

export default class ThreadIDCell extends React.Component<GridCustomCellProps> {
  public render() {
    if (!this.props.dataItem.ThreadID) {
      return <td {...this.props.tdProps} />
    }

    return (
      <td {...this.props.tdProps}>
        {(this.props.dataItem.ThreadID.startsWith("cnv_") || this.props.dataItem.ThreadID.startsWith("msg_")) ? <a
          target="_blank"
          style={{ color: '#007bff' }}
          href={`https://app.frontapp.com/open/${this.props.dataItem.ThreadID}`}
        >
          {this.props.dataItem.ThreadID}
        </a> : this.props.dataItem.ThreadID}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return nextProps.dataItem.ThreadID !== this.props.dataItem.ThreadID;
  }
}
